export default __webpack_public_path__ + "static/media/Mobile.80a7a2e9.svg";